import { gql } from '@apollo/client';

export default gql`
  mutation takeDeposit($bookingReference: String!, $payments: [PaymentInput]) {
    takeDeposit(bookingReference: $bookingReference, payments: $payments) {
      reference
      fulfillmentMethod {
        name
        description
      }
    }
  }
`;
